import { QUERY_KEYS } from '../../../../../consts';
import { getPatientMostRecentDealService } from '../../../../../services/patients/getters/get-patient-most-recent-deal.service';
import { getAtomWithMutation } from '../../../../../utils';

export const getPatientMostRecentDealAtom = getAtomWithMutation({
  mutationKey: QUERY_KEYS.PATIENTS.PATIENT_MOST_RECENT_DEAL,
  mutationFn: () => getPatientMostRecentDealService,
});
